import { ComponentClass } from 'react';
export { ComponentClass };

import { AttachmentIconProps, IconSize } from './components/AttachmentIconView';
import { AttachmentDocInfoProps } from './components/AttachmentDocInfoView';
import { AttachmentThumbnailProps } from './components/AttachmentThumbnailView';
import { CloudIconWithOverlayProps } from './components/CloudIconWithOverlay';
import getIconCSSForAttachment, { WellKnownFileIcon } from './utils/getIconCSSForAttachment';
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Attachments" */ './lazyIndex')
);

export const AttachmentThumbnailView = createLazyComponent(
    lazyModule,
    m => m.AttachmentThumbnailView
);

export const CloudIconWithOverlay = createLazyComponent(lazyModule, m => m.CloudIconWithOverlay);
export const AttachmentIconView = createLazyComponent(lazyModule, m => m.AttachmentIconView);
export const AttachmentDocInfoView = createLazyComponent(lazyModule, m => m.AttachmentDocInfoView);
export {
    AttachmentIconProps,
    AttachmentDocInfoProps,
    AttachmentThumbnailProps,
    CloudIconWithOverlayProps,
    IconSize,
};
export { getIconCSSForAttachment, WellKnownFileIcon };
